import { CookieAlertIcon } from './CookieAlertIcon';

/**
 * author: Colton Wiscombe
 * id D37F1726-BDD9-4AFB-84E0-A62587AAA6CC
 * name cookie-alert
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-alert.svg
 * tags
 * - Food / Drink 
 * - Alert / Error 
 */
export const BiscuitAlertIcon = CookieAlertIcon;
export default BiscuitAlertIcon